import { Navigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { GlobalLoader } from '@components/loader';
import { useStore } from '@stores/RootStore';

/**
 * 매니저 페이지 랜딩 컴포넌트
 * - 구독 관리자 전용(isSubscriptionOwnerOnly): /subscriptions/list로 리다이렉트
 * - 그 외 관리자: /home으로 리다이렉트
 */
export const ManagerLanding = observer(() => {
  const { authStore } = useStore();

  // AuthStore 초기화 대기 (roles 파싱 완료까지)
  if (!authStore.isInitialized) {
    return <GlobalLoader />;
  }

  // 구독 관리자 전용인 경우 구독 목록으로 리다이렉트
  if (authStore.isSubscriptionOwnerOnly) {
    return <Navigate to="subscriptions/list" replace />;
  }

  // 일반 관리자는 홈으로 리다이렉트
  return <Navigate to="home" replace />;
});
